(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["as-icon-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-as-filter-link][href]');
    if (!(link instanceof HTMLAnchorElement)) return;
    const container = link.closest('[data-as-icon-filters]');
    const section = container?.closest('.shopify-section');
    const form = section?.querySelector('facets-form-component');
    if (!form || typeof form.updateFiltersByURL !== 'function') return;
    event.preventDefault();
    form.updateFiltersByURL(link.href);
  });
  } catch(e) { console.error(e); }
})();

})();
